import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.546 13.887V7.275c0-.727-1.091-.727-1.091 0v6.612a2.186 2.186 0 0 0-1.568 1.567H8.909c-.727 0-.727 1.091 0 1.091h4.978a2.183 2.183 0 1 0 2.659-2.658ZM16 17.09a1.09 1.09 0 1 0 0-2.182 1.09 1.09 0 0 0 0 2.182ZM4 16C4 9.372 9.372 4 16 4s12 5.372 12 12-5.372 12-12 12S4 22.628 4 16Z",
    fill: "currentColor"
  }));
};

var SvgClock = styled(SvgComponent).withConfig({
  displayName: "Clock__SvgClock",
  componentId: "sc-1cf9wnb-0"
})(["", " ", ""], size, color);
export default SvgClock;